export interface KeyValueDto {
  key: string;
  value: string;
}

export interface KeyValueAsset {
  [key: string]: string;
}
